// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__Y3J54","cell":"ColumnAccessor_cell__2vPaX","firstCellAccent":"ColumnAccessor_firstCellAccent__3U9jF"};